"use client";

import React from "react";
import { BadgeDollarSign, BriefcaseBusiness, CalendarClock, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const details = [{
  id: "location",
  title: "Location",
  description: "1186 Roland St., Thunder Bay, Ontario. This role is primarily based at RiverBend’s Thunder Bay office.",
  icon: MapPin
}, {
  id: "employment-type",
  title: "Employment Type",
  description: "Full-time, permanent role focused on financial statement preparation, audit file development, and audit coordination.",
  icon: BriefcaseBusiness
}, {
  id: "application-deadline",
  title: "Application Deadline",
  description: "Applications are requested by March 31, 2026. Qualified candidates are encouraged to apply by email.",
  icon: CalendarClock
}, {
  id: "compensation",
  title: "Compensation",
  description: "$100,000 to $110,000 per year, plus comprehensive benefits and a Defined Contribution Pension Plan.",
  icon: BadgeDollarSign
}];
export default function ValuesSection() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262976" id="quick-job-details" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-secondary font-default font-bold tracking-wider uppercase text-sm mb-4">
            Position Overview
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-500 mb-6">
            Quick Job Details
          </h2>

          <p className="text-lg text-muted-foreground font-default leading-relaxed">This role is for a strong professional with a financial or accounting background who can take a lead role on assigned files, support financial statement preparation, coordinate audit-ready files, and help First Nation clients move delayed or complex reporting work forward.</p>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 transition-all duration-1000 ease-out delay-200 ${areCardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {details.map((item, i) => {
          const Icon = item.icon;
          return <Card key={item.id} data-index={i} className="h-full bg-card border border-border shadow-sm rounded-lg">
                <CardContent className="p-7 md:p-8">
                  <div className="size-12 rounded-md bg-secondary/10 flex items-center justify-center mb-5">
                    <Icon className="size-6 text-secondary" />
                  </div>

                  <h3 className="text-xl font-default font-bold text-primary-500 mb-3">
                    {item.title}
                  </h3>

                  <p className="text-muted-foreground font-default leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}